import { COLORS } from '@musinsa/mds';
import styled from 'styled-components';

import type { CarouselImageItem, GiftDetail as GiftDetailType } from '@/shared/@types';
import type { FC, ReactNode } from 'react';

import ImageViewer from '@/shared/modules/ImageViewer';
import { MdsTypography } from '@/shared/ui';
import { GiftCondition, GiftInfo, GiftNotice, UIGiftDetail } from '@/shared/ui/gift-detail';

type GiftDetailPageProps = {
  giftDetail: GiftDetailType;
  isPc?: boolean;
  children?: ReactNode;
};

const GiftDetailPage: FC<GiftDetailPageProps> = ({ giftDetail, isPc = false, children }) => {
  const images = [giftDetail.imageUrl, ...giftDetail.additionalImageUrls];
  const carouselImages: CarouselImageItem[] = images.map((src, index) => ({
    src: `${import.meta.env.VITE_APP_IMAGE_URL}${src}`,
    alt: `${giftDetail.giftName} 이미지 ${index + 1}`,
  }));

  return (
    <S.Container>
      {isPc && (
        <S.Header>
          <MdsTypography variant="textEtc16Med">사은품 상세</MdsTypography>
        </S.Header>
      )}

      <ImageViewer
        giftNo={giftDetail.giftNo}
        totalIndex={carouselImages.length}
        images={carouselImages.map((item) => item.src)}
      />

      <GiftInfo
        giftDetail={{
          giftName: giftDetail.giftName,
          stock: giftDetail.stock,
          startDateTime: giftDetail.startDateTime,
          endDateTime: giftDetail.endDateTime,
        }}
      />

      <GiftCondition
        giftDetail={{
          stock: giftDetail.stock,
          conditions: giftDetail.conditions,
          startDateTime: giftDetail.startDateTime,
          endDateTime: giftDetail.endDateTime,
        }}
      />

      <UIGiftDetail content={giftDetail.description} />

      <GiftNotice notice={giftDetail.notice} />

      {children}
    </S.Container>
  );
};

const S = {
  Container: styled.main`
    max-width: 600px;
    background-color: ${COLORS.white};
    min-height: 100vh;
  `,
  Header: styled.header`
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 16px;
    background-color: ${COLORS.gray[200]};
  `,
};

export { GiftDetailPage };
